/* eslint-disable */
// Do not edit this file, it is auto-generated at build time!
// See scripts/bootstrap.js to modify the generation of this file.
module.exports = {
  "sitecoreApiKey": "{B337054D-4868-4BBA-97F3-A248AB11AF85}",
  "sitecoreApiHost": "https://#{Server_Url}#",
  "jssAppName": "regus",
  "defaultLanguage": "en-US",
  "graphQLEndpointPath": "/api/regus",
  "graphQLEndpoint": "https://#{Server_Url}#/api/regus?sc_apikey={B337054D-4868-4BBA-97F3-A248AB11AF85}"
};